<template>
    <div style="background-color: white; min-height: 100vh; padding-bottom: 20px;">
        <CContainer>
            <div class="search-container">
      <CRow class="header-row mb-3 position-relative">
            <!-- Back Button on the Left -->
            <CCol class="col-auto">
                <CButton class="back-button" @click="$router.go(-1)">
                    ←
                </CButton>
                
            </CCol>
    
            <!-- Centered Title -->
            <CCol class="d-flex justify-content-center position-absolute start-50 translate-middle-x">
                <h3 class="section-title m-0">Search</h3>
            </CCol>
        </CRow>
        <div class="search-bar mt-5">
            <br />
            <input type="text" placeholder="Search Survey" />
        </div>
        <div class="recent-search">
            <h3 class="custom-14px-500">Recent Search</h3>
            <div class="recent-item" v-for="(search, index) in recentSearches" :key="index">
                <span><img src="../assets/img/new/frame.png" width="20px"/> {{ search }}</span>
                <img src="../assets/img/new/close.png" width="20px" @click="removeSearch(index)" />
            </div>
        </div>
        <hr class="custom-hr" />
        <div class="popular-survey">
            <h3 class="custom-14px-500 font-color-1A1A1A">Popular Survey</h3>
            <div class="survey-card" v-for="(survey, index) in surveys" :key="index">
                <div class="survey-image" :style="{ backgroundImage: `url(${survey.image})` }">
                    <div class="survey-content">
                        <h4 class="custom-12px-500 text-white mt-5">{{ survey.title }}</h4>
                        <!-- <p class="custom-11px-400 text-white">{{ survey.description }}</p> -->
                        <p v-html="formattedDescription(survey.description)"></p>
                        <div class="button-container text-right">
                            <CButton class="active-btn bg-white">
                                Start Survey
                            </CButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
        </CContainer>

    </div>
   
</template>
  
<script>
export default {
    data() {
        return {
            recentSearches: ["Food and Drinks Survey", "Electronics Survey"],
            surveys: [{
                    title: "Beauty Product Discount",
                    description: "Get A Discount Voucher Up To 50%! Help Us By Answering A Short Survey And Enjoy A Discount On Every Beauty Product Purchase At Glow Store.",
                    image: require("@/assets/img/new/beauty_survey.png")
                },
                {
                    title: "Cashback For Online Shopping",
                    description: "Complete The Survey, Get 30% Cashback! We Want To Hear Your Opinion! Complete This Survey And Enjoy Up To 30% Cashback For Shopping At ShopEase.",
                    image: require("@/assets/img/new/shopping_survey.png")
                }
            ]
        };
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        removeSearch(index) {
            this.recentSearches.splice(index, 1);
        },
        formattedDescription(desc) {
    return desc.replace(/(\d+%)/g, '<span style="font-size:20px; font-weight:700;">$1</span>');
  }
    }
};
</script>
  
<style scoped>
.search-container {
    padding: 20px;
    background: #fff;
}

.header {
    display: flex;
    align-items: center;
}

.back-button {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
}

.search-bar input {
    width: 100%;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #ccc;
    margin: 10px 0;
}

.recent-search h3,
.popular-survey h3 {
    margin-top: 20px;
}

.recent-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background: #f5f5f5;
    margin: 5px 0;
    border-radius: 5px;
}

.survey-card {
    margin: 10px 0;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
}

.survey-image {
    background-size: cover;
    background-position: center;
    height: 200px;
    position: relative;
}

.survey-content {
    background: rgba(0, 0, 0, 0.6);
    color: white;
    padding: 10px;
    position: absolute;
    bottom: 0;
    width: 100%;
}

.start-button {
    background: #6a5acd;
    color: white;
    border: none;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
}
.button-container {
    display: flex;
    justify-content: flex-end; /* Aligns button to the right */
}

</style>
  